import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DataRoutingModule } from './data-routing.module';
import { ManageAutoItComponent } from './manage-auto-it/manage-auto-it.component';
import { ManageLocalizationComponent } from './manage-auto-it/manage-localization/manage-localization.component';
import { ManageBugComponent } from './manage-bug/manage-bug.component';
import { ManageJavascriptComponent } from './manage-javascript/manage-javascript.component';
import { ManagePythonScriptComponent } from './manage-python-script/manage-python-script.component';
import { ManageSqlScriptComponent } from './manage-sql-script/manage-sql-script.component';
import { SharedModule } from '../shared/shared.module';
import { AngularMaterialModule } from '../angular-material.module';
import { ManageTestDataComponent } from './manage-test-data/manage-test-data.component';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { LayoutModule } from '../layout/layout.module';

@NgModule({
  declarations: [ ManageTestDataComponent, ManageSqlScriptComponent, ManagePythonScriptComponent, ManageJavascriptComponent, ManageBugComponent, ManageLocalizationComponent, ManageAutoItComponent ],
  imports: [
    CommonModule,
    DataRoutingModule,
    SharedModule,
    AngularMaterialModule,
    LayoutModule,
    CodemirrorModule,
    
    
  ]
})
export class DataModule { }
